import { Component, OnInit } from '@angular/core';
import * as AOS from 'aos';
@Component({
  selector: 'mm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Main';
  ngOnInit() {
    AOS.init({ once: false, offset: 0, mirror: true,debounceDelay: 50 });
  }
}
